module.exports = __webpack_public_path__ + "static/media/Fiserv-logo-vector.91b0727d.svg";